module.exports = __webpack_public_path__ + "static/img/right-bottom-row-2.665c0f89.png";